// extracted by mini-css-extract-plugin
export default {"icon":"SaibaMais_icon__rL37n","SaibaMais":"SaibaMais_SaibaMais__No1kt"};